import { IAnnotation } from "@bronte/viewer-api/src/main";

export type KeyValue = {
  [key: string]: string;
};

export type SpotlightAudio = {
  ttsURL?: string;
  /** When set, load TTS from `{localAudioBaseUrl}/{lessonId}.json` and `.opus` instead of proxy. */
  localAudioBaseUrl?: string;
  wordHighlightColor: string;
  sentenceHighlightColor: string;
  maxSpotlights?: number;
};

export type URLParams = {
  cohortId: string;
  deploymentId: string;
  env: string;
  pocEnabled: string;
  disableIES: string;
  screenId: string;
  userId: string;
  token: string;
  /** Raw query value when present; does not affect resolved `packagePath` if `packagePath` query is set. */
  exportId: string;
  packagePath: string;
  /** `exportId` launch: gateway signed cookies + assets under launch origin. Explicit `packagePath`: direct fetch. */
  securePackageAccess: boolean;
  /** When true, hide most dev-shell tool menu items; TOC and Notebook remain visible. */
  minimalShell: boolean;
};

export enum DrawerTypes {
  TOC,
  SETTINGS,
  NOTEBOOK,
  AUDIOBOOK,
  FLASHCARD,
  SEARCH,
}

export interface IAnnotationData extends IAnnotation {
  actionType?: string;
  screenTitle?: string;
  flashcardFrontText?: string;
  flashcardBackText?: string;
  pageId?: string;
}

export type SpotlightOffsetData = {
  startOffset: number;
  length: number;
};

export type PageNumberData = {
  screenId: string;
  dataId: string;
};
